import React from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import Hero from "@/components/sections/Hero";
import WhyF3 from "@/components/sections/WhyF3";
import Platform from "@/components/sections/Platform";
import Solutions from "@/components/sections/Solutions";
import Market from "@/components/sections/Market";
import About from "@/components/sections/About";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <div className="App font-body bg-black text-white relative noise overflow-hidden">
      {/* Royal-purple ambient aura — sits behind everything */}
      <div className="pointer-events-none fixed inset-0 -z-0">
        <div className="absolute -top-1/4 -left-1/4 w-[900px] h-[900px] rounded-full bg-violet-700/20 blur-[180px]" />
        <div className="absolute top-1/3 -right-1/4 w-[800px] h-[800px] rounded-full bg-purple-600/15 blur-[180px]" />
        <div className="absolute bottom-0 left-1/3 w-[700px] h-[700px] rounded-full bg-fuchsia-700/10 blur-[200px]" />
      </div>
      <div className="relative z-10">
      <Navigation />
      <main>
        <Hero />
        <WhyF3 />
        <Platform />
        <Solutions />
        <Market />
        <About />
        <Contact />
      </main>
      <Footer />
      </div>
    </div>
  );
}

export default App;
